/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/collections/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * - VALUE_SCALAR_TYPE_UNSPECIFIED: Unspecified value type
 - VALUE_SCALAR_TYPE_TEXT: A text value type
 - VALUE_SCALAR_TYPE_NUMBER: A number value type
 - VALUE_SCALAR_TYPE_BOOLEAN: A boolean value type
 - VALUE_SCALAR_TYPE_DATETIME: A datetime value type
 - VALUE_SCALAR_TYPE_DATE: A date value type
 - VALUE_SCALAR_TYPE_TIME: A time value type
 - VALUE_SCALAR_TYPE_FILE: A file value type
 - VALUE_SCALAR_TYPE_TIMEDELTA: A timedelta value type
 */
export type V1ValueScalarType =
  (typeof V1ValueScalarType)[keyof typeof V1ValueScalarType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1ValueScalarType = {
  VALUE_SCALAR_TYPE_UNSPECIFIED: 'VALUE_SCALAR_TYPE_UNSPECIFIED',
  VALUE_SCALAR_TYPE_TEXT: 'VALUE_SCALAR_TYPE_TEXT',
  VALUE_SCALAR_TYPE_NUMBER: 'VALUE_SCALAR_TYPE_NUMBER',
  VALUE_SCALAR_TYPE_BOOLEAN: 'VALUE_SCALAR_TYPE_BOOLEAN',
  VALUE_SCALAR_TYPE_DATETIME: 'VALUE_SCALAR_TYPE_DATETIME',
  VALUE_SCALAR_TYPE_DATE: 'VALUE_SCALAR_TYPE_DATE',
  VALUE_SCALAR_TYPE_TIME: 'VALUE_SCALAR_TYPE_TIME',
  VALUE_SCALAR_TYPE_FILE: 'VALUE_SCALAR_TYPE_FILE',
  VALUE_SCALAR_TYPE_TIMEDELTA: 'VALUE_SCALAR_TYPE_TIMEDELTA',
} as const;
